import React from "react";
import {SalesPackageOption} from "../../../../components/SalesPackage/SalesPackageOption";
import {SalesPackage} from "../../../../components/SalesPackage";
import {VehicleGroup} from "../../../../model/vehicle";
import {strings} from "../../../../strings/strings";
import {sumInsuredFormat} from "../../../../utils/format";
import useSwitchToNewContent from "../../../../utils/hooks/useSwitchToNewContent";

interface CASCOPackage {
    vehicleGroup: VehicleGroup;
    premium: number;
    totalPremium: number;
    deductible: number;
    selected: boolean;
    onSelect: () => void;
    packageName: string;
    more: React.ReactElement;
}

export const CASCOPackage = (props: CASCOPackage) => {
    const {premium, selected, onSelect, vehicleGroup, deductible, packageName, more, totalPremium} = props;
    const showNewContent = useSwitchToNewContent()

    return (
        <SalesPackage name={packageName}
                      premium={premium}
            selected={selected}
            onSelect={onSelect}
            popular={true}
            totalPremium={totalPremium}
            vehicleGroup={vehicleGroup}
            more={more}>
            <SalesPackageOption name={strings.packageOptionMtplName}
                tooltipPlacement={"left"}
                tooltip={<ul>
                    <li>{showNewContent ? strings.packageOptionMtplText1in2025 : strings.packageOptionMtplText1}</li>
                    <li>{showNewContent ? strings.packageOptionMtplText2in2025 : strings.packageOptionMtplText2}</li>
                </ul>}
                covered={true} />
            <SalesPackageOption
                name={`${strings.franchise} ${sumInsuredFormat(deductible)} ${strings.currencyUAH}`}
                tooltipPlacement={"left"}
                tooltip={<div><span
                    className={"accent"}>{strings.franchise2}</span>{strings.franchiseDescription}</div>}
                covered={true} />
            <SalesPackageOption name={strings.packageOptionCascoName}
                covered={true} />
        </SalesPackage>
    )

};